<div class="subtitles">
  <span>{{ viewerState.currentCaption }}</span>
</div>
